export enum WacPagesEvents {
  REFRESH_COMPONENT = 'refreshWacPagesComponent',
}

export interface Dependencies {
  api: {
    type: string;
    clients?: any;
  };
  translateFn: Function,
  getTimezone: Function,
  getUserLanguage : Function
}
